import { Button, Tooltip } from "antd"
import Select from "antd"
import { usePaginationBezPrzekazania } from "../../../context/PaginationContextBezPrzekazania"
const FastFilters = () => {
    const { pagination, setPagination } = usePaginationBezPrzekazania();
    const buttons = [
        {
            label: "Wszystkie",
            value: null,
            tooltip: "Pokazuje wszystkie wpływy"
        },
        {
            label: "Nierozliczone",
            value: 'nierozliczone',
            tooltip: "Pokazuje wszystkie wpływy, które nie mają dodanych osób, mają uzupełnione tylko podstawowe dane w etapie 'Dane wpływu' oraz ich rozliczenie jest w trakcie."
        },
        {
            label: "W trakcie rozliczania",
            value: 'w_trakcie_rozliczenia',
            tooltip: "Pokazuje wszystkie wpływy, które mają dodane osoby i są na etapach późniejszych niż etap pierwszy. Wpływy nie są rozliczone, czyli nie mają zatwierdzonych przelewów."
        },
        {
            label: "Rozliczone i niewykonane",
            value: 'rozliczone_niewykonane',
            tooltip: "Pokazuje wszystkie wpływy, które mają uzupełnione wszystkie etapy, przelewy są zatwierdzone ale jeszcze nie wygenerowane/wykonane."
        },
        {
            label: "Rozliczone i wykonane",
            value: 'rozliczone_wykonane',
            tooltip: "Pokazuje wszystkie wpływy, które mają uzupełnione wszystkie etapy, przelewy są zatwierdzone i wykonane."
        },
    ]
    const buttonStyle = {
        width: '100%',
    }
    return <div style={{display: 'flex', gap: '10px', width: '100%'}}>
        {buttons.map((button)=>
            <Tooltip title={button.tooltip}>
                <Button disabled={pagination.loading} type={pagination.specialfilter === button.value ? "primary" : 'default'} style={buttonStyle} onClick={() => setPagination({...pagination, specialfilter: button.value})}>{button.label}</Button>
            </Tooltip>
        )}
    </div>
}
export default FastFilters